{
  "shellSkipMenuMainContent": "Skip to main content"
}
